import { createAsyncThunk } from '@reduxjs/toolkit';
import { TeleconsultationActions } from 'applicaiton/constants/actions';
import { AxiosError } from 'axios';
import { AppointmentsApi } from 'integration/api/appointments';
import { ChatsAPI } from 'integration/api/chats';

/**
 * Gets the teleconsultation connection data.
 * @param id - The appointment ID.
 * @returns The teleconsultation connection data.
 */
export const getConnectionData = createAsyncThunk(
  TeleconsultationActions.getConnectionData,
  async (id: string, { rejectWithValue }) => {
    try {
      const { data } = await AppointmentsApi.getTeleconsultationConnectionData(
        id,
      );
      return data;
    } catch (e) {
      const error = e as AxiosError;
      return rejectWithValue(error.message);
    }
  },
);

/**
 * Gets the teleconsultation connection data by room ID.
 * @param roomId - The chat room ID.
 * @returns An object containing the room ID and access token.
 */
export const getConnectionDataByRoomId = createAsyncThunk(
  TeleconsultationActions.getConnectionDataByRoomId,
  async (roomId: string, { rejectWithValue }) => {
    try {
      const { data } = await ChatsAPI.createTeleconsultationTokenByRoomId(
        roomId,
      );
      return {
        room: roomId,
        accessToken: data,
      };
    } catch (e) {
      const error = e as AxiosError;
      return rejectWithValue(error.message);
    }
  },
);

/**
 * Creates a chat for the teleconsultation.
 * @param id - The appointment ID.
 */
export const createChat = createAsyncThunk(
  TeleconsultationActions.createChat,
  async (id: string, { rejectWithValue }) => {
    try {
      await AppointmentsApi.createTeleconsultationChat(id);
    } catch (e) {
      const error = e as AxiosError;
      return rejectWithValue(error.message);
    }
  },
);
